import { useEffect, useState } from 'react';
import './App.css';
import Screen01 from './components/Screen01';
import Screen02 from './components/Screen02';
import Screen03 from './components/Screen03';
import Screen04 from './components/Screen04';

function App() {
  const [phase, setPhase] = useState(0);
  const [language, setLanguage] = useState('');
  const [award, setAward] = useState(null);
  
  const [screen, setScreen] = useState(<Screen01 phase={phase} setPhase={setPhase} language={language} setLanguage={setLanguage}/>)
  useEffect(()=>{
    if (phase === 0) {
      setScreen(<Screen01 phase={phase} setPhase={setPhase} language={language} setLanguage={setLanguage}/>)
    }
    if (phase === 1) {
      setScreen(<Screen02 phase={phase} setPhase={setPhase} language={language} setLanguage={setLanguage}/>)
    }
    if (phase === 2) {
      setScreen(<Screen03 phase={phase} setPhase={setPhase} language={language} setLanguage={setLanguage} award={award} setAward={setAward}/>)
    }
    if (phase === 3) {
      setScreen(<Screen04 phase={phase} setPhase={setPhase} language={language} setLanguage={setLanguage}  award={award} setAward={setAward}/>)
    }
  },[phase, language, award])
  return (
    <div className="App" style={{
      height: window.innerHeight,
    }}>
      {screen}
    </div>
  );
}

export default App;
